import { render, staticRenderFns } from "./FollowInterestDelete.vue?vue&type=template&id=2b74e444&"
import script from "./FollowInterestDelete.vue?vue&type=script&lang=js&"
export * from "./FollowInterestDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports